import * as React from 'react';
import {Container} from "@mui/material";
import {styled} from "@mui/material/styles";

const StyledContainer = styled(Container)(({ theme }) => ({

    '& .MuiContainer-root': {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        '&>.MuiPaper-root': {
            padding: theme.spacing(4),
            borderRadius: theme.spacing(2),
            maxWidth: '1000px',
            boxShadow: '0px 3px 10px -4px rgba(0,0,0,0.2)',
        },
        '& .title': {
            fontSize: '2.5rem',
            fontWeight: '300',
            marginBottom: theme.spacing(2),
        },
        '& .footer': {
            marginTop: '1.5rem',
            marginLeft: '60px',
            maxWidth: '1000px',
        }
    },
}));

export const AuthContainer = ({children, styles}) => {

    return (
        <>
            <StyledContainer component="main" sx={{ ...styles }}>
                {children}
            </StyledContainer>
        </>
    );
}